import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { api, BASE_URL } from "../../env";
import { useState, useRef } from "react";

const DerogationView = ({ visible, onHide, derogation, language }) => {
  const toast = useRef(null);
  const [showRejectionInput, setShowRejectionInput] = useState(false);
  const [motifRejet, setMotifRejet] = useState("");
  if (!derogation) return null;

  const rejeter = async (status) => {
    try {
      await api.put(`/api/derogations/${derogation.id}/reject`, {
        motif_rejet: motifRejet,
      });

      toast.current?.show({
        severity: "success",
        summary: language === "ar" ? "تم التحديث" : "Mise à jour",
        detail:
          language === "ar"
            ? `تم تحديث الحالة إلى ${status}`
            : `Statut mis à jour vers ${status}`,
        life: 4000,
      });

      onHide(); // Close dialog
    } catch (error) {
      console.error("Error updating statut:", error);
      toast.current?.show({
        severity: "error",
        summary: language === "ar" ? "خطأ" : "Erreur",
        detail:
          language === "ar"
            ? "حدث خطأ أثناء تحديث الحالة"
            : "Erreur lors de la mise à jour du statut",
        life: 4000,
      });
    }
  };

  const Valider = async (status) => {
    try {
      ;
      await api.put(`/api/derogations/${derogation.id}/accept`, {});

      toast.current?.show({
        severity: "success",
        summary: language === "ar" ? "تم التحديث" : "Mise à jour",
        detail:
          language === "ar"
            ? `تم تحديث الحالة إلى ${status}`
            : `Statut mis à jour vers ${status}`,
        life: 4000,
      });

      onHide(); // Close dialog
    } catch (error) {
      console.error("Error updating statut:", error);
      toast.current?.show({
        severity: "error",
        summary: language === "ar" ? "خطأ" : "Erreur",
        detail:
          language === "ar"
            ? "حدث خطأ أثناء تحديث الحالة"
            : "Erreur lors de la mise à jour du statut",
        life: 4000,
      });
    }
  };

  // Helper to render file link if present
  const renderFileLink = (derogationId, fieldName, label) => {
    if (!derogationId || !fieldName) {
      return <p>{language === "ar" ? "لا يوجد ملف" : "No file"}</p>;
    }

    const downloadUrl = `${BASE_URL}/api/derogations/${derogationId}/download/${fieldName}?isadmin=true`;

    const handleDownload = async () => {
      try {
        // Axios GET with responseType blob to get file data
        const response = await api.get(downloadUrl, { responseType: "blob" });

        // No .ok in Axios, check status instead
        if (response.status !== 200) {
          throw new Error("Network response was not ok");
        }

        // response.data is the Blob
        const blob = response.data;

        const url = window.URL.createObjectURL(blob);

        window.open(url);

        setTimeout(() => window.URL.revokeObjectURL(url), 10000);
      } catch (error) {
        console.error("Error downloading file:", error);
        toast.current?.show({
          severity: "error",
          summary: language === "ar" ? "خطأ" : "Erreur",
          detail:
            language === "ar" ? "خطأ في تحميل الملف" : "Error downloading file",
          life: 5000,
        });
      }
    };

    return (
      <p>
        <strong>{label}:</strong>{" "}
        <button onClick={handleDownload}>
          {language === "ar" ? "عرض الملف" : "Afficher le fichier"}
        </button>
      </p>
    );
  };

  return (
    <Dialog
      header={
        language === "ar" ? "تفاصيل التنازل" : "Détails de la cession du bien"
      }
      visible={visible}
      style={{ width: "50vw" }}
      modal
      onHide={onHide}
    >
      <Card>
        <p>
          <strong>{language === "ar" ? "الاسم" : "Nom"}:</strong>{" "}
          {derogation.nom}
        </p>
        <p>
          <strong>{language === "ar" ? "اللقب" : "Prénom"}:</strong>{" "}
          {derogation.prenom}
        </p>
        <p>
          <strong>{language === "ar" ? "الرقم الوطني" : "NIN"}:</strong>{" "}
          {derogation.nin}
        </p>
        <p>
          <strong>{language === "ar" ? "البريد الإلكتروني" : "Email"}:</strong>{" "}
          {derogation.email}
        </p>
        <p>
          <strong>{language === "ar" ? "الهاتف" : "Téléphone"}:</strong>{" "}
          {derogation.telephone}
        </p>
        <p>
          <strong>{language === "ar" ? "الحالة" : "Statut"}:</strong>{" "}
          {derogation.statut}
        </p>
        {derogation.statut === "Rejete" && (
          <p style={{ color: "red" }}>
            <strong>
              {language === "ar" ? "سبب الرفض" : "Motif de rejet"}:
            </strong>{" "}
            {derogation.motif_rejet}
          </p>
        )}

        {renderFileLink(
          derogation.id,
          "carte_national_path",
          language === "ar" ? "بطاقة وطنية" : "Carte Nationale"
        )}
        {renderFileLink(
          derogation.id,
          "extrait_naissance_path",
          language === "ar" ? "استخراج الميلاد" : "Extrait de Naissance"
        )}
        {renderFileLink(
          derogation.id,
          "extrait_naissance_epouse_path",
          language === "ar"
            ? "استخراج ميلاد الزوجة"
            : "Extrait de Naissance Épouse"
        )}
        {renderFileLink(
          derogation.id,
          "copie_contrat_loyer_path",
          language === "ar" ? "نسخة عقد الإيجار" : "Copie Contrat Loyer"
        )}
        {renderFileLink(
          derogation.id,
          "copie_derniere_quittance_path",
          language === "ar" ? "نسخة آخر وصل دفع" : "Copie Dernière Quittance"
        )}
      </Card>
      {!["Acceptee", "Rejete"].includes(derogation.statut) && (
        <>
          {!showRejectionInput ? (
            <div className="flex justify-content-end gap-2 mt-3">
              <button
                onClick={() => Valider("Acceptee")}
                className="p-button p-component p-button-success"
              >
                {language === "ar" ? "قبول" : "Valider"}
              </button>
              <button
                onClick={() => setShowRejectionInput(true)}
                className="p-button p-component p-button-danger"
              >
                {language === "ar" ? "رفض" : "Rejeter"}
              </button>
            </div>
          ) : (
            <div className="mt-3">
              <label>
                {language === "ar" ? "سبب الرفض" : "Motif de rejet"}:
              </label>
              <textarea
                value={motifRejet}
                onChange={(e) => setMotifRejet(e.target.value)}
                rows={3}
                className="p-inputtext p-component w-full"
                placeholder={
                  language === "ar"
                    ? "أدخل سبب الرفض"
                    : "Enter reason for rejection"
                }
              />
              <div className="flex justify-content-end gap-2 mt-2">
                <button
                  className="p-button p-component p-button-secondary"
                  onClick={() => setShowRejectionInput(false)}
                >
                  {language === "ar" ? "إلغاء" : "Annuler"}
                </button>
                <button
                  className="p-button p-component p-button-danger"
                  onClick={() => rejeter("Rejete")}
                  disabled={!motifRejet.trim()}
                >
                  {language === "ar" ? "تأكيد الرفض" : "Confirmer le rejet"}
                </button>
              </div>
            </div>
          )}
          <Toast ref={toast} />
        </>
      )}
    </Dialog>
  );
};

export default DerogationView;
